import { render, staticRenderFns } from "./UserProjects.vue?vue&type=template&id=927a16f0&scoped=true&"
import script from "./UserProjects.vue?vue&type=script&lang=js&"
export * from "./UserProjects.vue?vue&type=script&lang=js&"
import style0 from "./UserProjects.vue?vue&type=style&index=0&id=927a16f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927a16f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VSpacer})
